import { HasChildren } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { PaginationResponse } from '$shared/types';

import {
  Pagination as PaginationLib,
  PaginationProps as PaginationLibProps,
} from './pagination/index';

const defaultPageSizes = [10, 25, 50, 100];

export interface PaginationProps extends HasChildren {
  paginationData: PaginationResponse;
  onPageSizeChange: (newSize: string) => void;
  onPageChange: (newPage: number) => void;
  pageSizeOptions?: PaginationLibProps['pageSizeOptions'];
  showItemRange?: PaginationLibProps['showItemRange'];
  showPageSize?: PaginationLibProps['showPageSize'];
}

export function Pagination({
  paginationData,
  onPageSizeChange,
  onPageChange,
  pageSizeOptions = defaultPageSizes,
  showItemRange,
  showPageSize,
}: PaginationProps): ReactElement {
  const { t } = useTranslation();

  return (
    <PaginationLib
      selectLabel={t('pagination.pageSize')}
      itemRangeLabel={(startItem, endItem) =>
        t('pagination.itemRange', {
          startItem,
          endItem,
          totalItems: paginationData.totalItems,
        })
      }
      paginationData={{ ...paginationData, currentPage: paginationData.page }}
      pageSizeOptions={pageSizeOptions}
      showItemRange={showItemRange}
      showPageSize={showPageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
}
